<div class="rest_dra">
    <div class="frm_date_dra">
        <div class="page-title-bar mb-4 flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start">
            <div class="title d-flex align-items-center">
              <button  mat-icon-button (click)="navigate()"  class="me-3">
                <mat-icon class="material-icons-round">arrow_back</mat-icon>
              </button>
              <div>
                <h1 >{{pageTitle |titlecase}}</h1>
                <h2 class="m-0" *ngIf="pageSubTitle">{{pageSubTitle}}</h2>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>
            
            <button *ngIf="showButton" mat-button >{{showButton}}</button>
          </div>
        <!-- <div class="row">
            <button (click)="openAddDate()">Add Date</button>
        </div> -->
        <div class="row" style="
        padding-left: 15px">
            
            <div class="col-sm-5">
                <div class="res_fll_sed">
                    <div class="row">
                        <div class="col-sm-1">
                            <label>From</label>
                        </div>
                        <div class="col-sm-5" style="
                        padding-left: 20px;
                    ">
                            <input type="date" name="fromDate" [(ngModel)]="fromDate">
                        </div>

                        <div class="col-sm-1">
                            <label class="ret_tde">To</label>
                        </div>
                        <div class="col-sm-5" style="
                        padding-left: 20px;
                    ">
                            <input type="date" name="toDate" [(ngModel)]="toDate">
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="in_btn_dra">
                    <button (click)="search()">Search</button>
                </div>
            </div>
           
        </div>
    </div>
    
</div>

<div *ngIf="loader" class="loader">
  <mat-spinner></mat-spinner>
</div>
<mat-card *ngIf="visible">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="messageList"
           [showPagination]="true" [itemsPerPage]="5" [showMenuButton]="true"  [menuDropdownTemplate]="menuTemplate">
           
           <ng-template #costTemplate let-rowVal="row" let-colVal="col">
            {{rowVal[colVal.columnProperty] | currency: 'INR'}}
          </ng-template>
      </sm-data-table>
    </div>
  </mat-card>

  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item>
      <mat-icon class="material-icons-outlined">account_balance</mat-icon>
      <span>Refund</span>
    </button>
 
  </ng-template>
